import { useEffect, useState } from 'react'

export default function Countdown({ value = 0, onTimeout = () => {} }) {
  const [minute, setMinute] = useState(Math.floor(value / 60))
  const [second, setSecond] = useState(value % 60)

  useEffect(() => {
    let interval = setInterval(() => {
      if (second > 0) {
        setSecond(second - 1)
      }
      if (second === 0) {
        if (minute === 0) {
          onTimeout()
          clearInterval(interval)
        } else {
          setMinute(minute - 1)
          setSecond(59)
        }
      }
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [second, minute, onTimeout])

  return (
    <span>
      {minute > 9 ? minute : <>0{minute}</>}:
      {second > 9 ? second : <>0{second}</>}
    </span>
  )
}
